exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear {\n  text-align: justify;\n}\n.lock-pinned {\n  color: rgba(0, 0, 0, 0.3);\n}\n", ""]);

// exports
